import { DateTime, DateTimeOptions } from 'luxon';

/**
 * A date that may be malformed, parsed without throwing.
 *
 * lib/datettime.ts sets `Settings.throwOnInvalid = true` for the whole app, so
 * `DateTime.fromISO('2026-13-45')` THROWS (a month of 13) instead of returning
 * an invalid DateTime, and an `.isValid` check after it never runs. A string
 * that comes from a form, a query, a stored record or the voice agent must go
 * through here: the result is a valid DateTime or null.
 */
export function isoOrNull(text: string | null | undefined, options?: DateTimeOptions): DateTime | null {
  if (!text) return null;

  try {
    const parsed = DateTime.fromISO(text, options);

    return parsed.isValid ? parsed : null;
  } catch {
    return null;
  }
}

/** Epoch milliseconds from a malformed-tolerant ISO string, or null. */
export function isoMillisOrNull(text: string | null | undefined, options?: DateTimeOptions): number | null {
  return isoOrNull(text, options)?.toMillis() ?? null;
}
